import { NAME_SERVER } from "./NAME_HOST";
import useSound from "use-sound"
import sound_manualBtn from "../assets/sounds/click_manualBTN.mp3"
// Создание звуков с предзагрузкой
const manualBtnSound = new Audio(sound_manualBtn)
const succses_bet = new Audio(NAME_SERVER + "/assets/sounds/succses_bet.mp3");
const sound_win = new Audio(NAME_SERVER + "/assets/sounds/sound_win.mp3");
const sound_winGAME = new Audio(NAME_SERVER + "/assets/sounds/sound_winGAME.mp3");
const open_modal_sound = new Audio(NAME_SERVER + "/assets/sounds/pop-up-modal.mp3");
const sound_spin_wheel = new Audio(NAME_SERVER + "/assets/sounds/roulette_spin.mp3");
const error_sound = new Audio(NAME_SERVER + "/assets/sounds/error_sound.mp3");

// Установка громкости
succses_bet.volume = 0.5;
sound_winGAME.volume = 1;
open_modal_sound.volume = 0.6;
sound_spin_wheel.volume = 0.5;
error_sound.volume = 0.5;

// Предзагрузка аудиофайлов
[manualBtnSound, succses_bet, sound_win, sound_winGAME, open_modal_sound, sound_spin_wheel, error_sound].forEach(sound => {
    sound.preload = 'auto'; // Предзагрузка для улучшения воспроизведения
    sound.load();
});

// Экспорт звуков
export {
    manualBtnSound,
    succses_bet,
    sound_win,
    error_sound,
    sound_winGAME,
    open_modal_sound,
    sound_spin_wheel
};